// 修改透氧量弹窗
import { InputNumber, Modal, Form, Input } from 'antd';
import { isNaN } from 'lodash';
import React, { Component } from 'react';
class OxygenPermeabilityModal extends Component {
  constructor(props) {
    super(props);
    this.state = {

    }
  }
  baseFormRef = React.createRef();
  componentDidMount() {
    this.baseFormRef.current.setFieldsValue({
      oxygenCount_hPa: this.props.oxygenCountHPa,
      oxygenCount_mmhg: this.props.oxygenCountMmhg,
    })
  }

  toOxygenCountMmhg = () => {
    let value = Number(this.baseFormRef.current.getFieldValue("oxygenCount_hPa")) || 0
    this.baseFormRef.current.setFieldsValue({
      oxygenCount_mmhg: (value * 1.33322).toFixed(2)
    })
  }
  toOxygenCountHPa = () => {
    let value = Number(this.baseFormRef.current.getFieldValue("oxygenCount_mmhg")) || 0
    this.baseFormRef.current.setFieldsValue({
      oxygenCount_hPa: (value / 1.33322).toFixed(2)
    })
  }

  onOk = () => {
    console.log(this.props)
    let hpa = this.baseFormRef.current.getFieldValue("oxygenCount_hPa")
    let mmhg = this.baseFormRef.current.getFieldValue("oxygenCount_mmhg")
    this.props.onOk({ hpa, mmhg, id: this.props.id })
  }
  render() {
    const { open } = this.props
    return (
      <Modal
        title="透氧量填写"
        width={620}
        onCancel={this.props.onCancel}
        visible={open}
        onOk={this.onOk}
      >
        <Form
          labelCol={{ span: 5 }}
          wrapperCol={{ span: 19 }}
          ref={this.baseFormRef}
          style={{ position: "relative" }}
        >
          <Form.Item label="透氧量(hPa)">
            <Input.Group compact>
              <Form.Item
                name="oxygenCount_hPa"
                noStyle
                rules={[{ required: false }]}
              >
                <InputNumber placeholder='请填写' style={{ width: 200 }} precision={2} />
              </Form.Item>
              <Form.Item
                rules={[{ required: false }]}
              >
                <span className='ml16'>x10^</span>
                <span>-9</span>
                <span className=''>(cm/s)[mLO
                  <span>2</span>
                  <span className=''>/(mL</span>
                  <span> x </span>
                  hPa)]</span>
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              return prevValues.oxygenCount_hPa !== currentValues.oxygenCount_hPa;
            }}
          >
            {({ getFieldValue }) => (
              <Input.Group compact>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 220, left: 115 }}
                >
                  {
                    (getFieldValue("oxygenCount_hPa") || getFieldValue("oxygenCount_hPa") === 0) && (
                      (Number(getFieldValue("oxygenCount_hPa") || 0)).toFixed(2) + "Dk/t单位(hPa)"
                    )
                  }
                </Form.Item>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 200, right: -50 }}
                >
                  <div style={{ width: 3, height: 90, background: "#ccc", marginTop: 13 }}></div>
                  <div style={{ position: "absolute", left: -14, top: -2, width: 0, height: 0, borderLeft: "15px solid transparent", borderRight: "15px solid transparent", borderBottom: "15px solid #ccc" }}></div>
                  <a style={{ position: "absolute", top: 35, left: 10 }} onClick={this.toOxygenCountHPa}>转换</a>
                </Form.Item>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 200, right: -161 }}
                >
                  <div style={{ width: 3, height: 90, background: "#ccc" }}></div>
                  <div style={{ position: "absolute", left: -14, bottom: -15, width: 0, height: 0, borderLeft: "15px solid transparent", borderRight: "15px solid transparent", borderTop: "15px solid #ccc" }}></div>
                  <a style={{ position: "absolute", top: 35, left: 10 }} onClick={this.toOxygenCountMmhg}>转换</a>
                </Form.Item>
              </Input.Group>
            )}
          </Form.Item>
          <Form.Item label="透氧量(mmhg)" style={{ marginTop: 50 }}>
            <Input.Group compact>
              <Form.Item
                name="oxygenCount_mmhg"
                noStyle
                rules={[{ required: false }]}
              >
                <InputNumber placeholder='请填写' style={{ width: 200 }} precision={2} />
              </Form.Item>
              <Form.Item
                rules={[{ required: false }]}
              >
                <span className='ml16'>x10^-9(cm/s)[mLO2/(mL x mmHg)]</span>
              </Form.Item>
            </Input.Group>
          </Form.Item>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, currentValues) => {
              return prevValues.oxygenCount_mmhg !== currentValues.oxygenCount_mmhg;
            }}
          >
            {({ getFieldValue }) => (
              <Input.Group compact>
                <Form.Item
                  rules={[{ required: false }]}
                  style={{ position: "absolute", top: -50, width: 220, left: 115 }}
                >
                  {
                    (getFieldValue("oxygenCount_mmhg") || getFieldValue("oxygenCount_mmhg") === 0) && (
                       (Number((getFieldValue("oxygenCount_mmhg") || 0))).toFixed(2) + "Dk/t单位(mmHg)"
                    )
                  }
                </Form.Item>
              </Input.Group>
            )}
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

export default OxygenPermeabilityModal;


// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/addinfomation/components/oxygenPermeabilityModal.jsx